import * as React from 'react';

import type { ProgressLabelAlign } from './ProgressFieldWrapper';

export interface ProgressGroupContextValue {
  /** When true, each Progress renders its label and track as sibling grid cells. */
  grouped: boolean;
  /** Default label alignment for every row; a Progress may still override it. */
  labelAlign?: ProgressLabelAlign;
}

export const ProgressGroupContext =
  React.createContext<ProgressGroupContextValue | null>(null);

export function useProgressGroup(): ProgressGroupContextValue | null {
  return React.useContext(ProgressGroupContext);
}
